import { CargoCompanyOrderBillingsListItem } from "../../../../../common/services/cargo-company/order-billings/list/cargo-company-order-billings-list";
import BillingType from "../../../../../common/types/billing-type";
import BillingsCargoOrderListingItem from "./types/billings-cargo-order-listing-item";
import BillingsCargoOrderListingItemBillingStatus from "./types/billings-cargo-order-listing-item-billing-status";
import BillingsCargoOrderListingItemBillingType from "./types/billings-cargo-order-listing-item-billing-type";

const createListingItemStatus = (
  responseDataItem: CargoCompanyOrderBillingsListItem,
): BillingsCargoOrderListingItemBillingStatus | undefined => {
  switch (responseDataItem.status) {
    case "CREATED":
      return BillingsCargoOrderListingItemBillingStatus.CREATED;
    case "ACCEPTED":
      return BillingsCargoOrderListingItemBillingStatus.ACCEPTED;
    case "REJECTED":
      return BillingsCargoOrderListingItemBillingStatus.REJECTED;
    case "REOPENED":
      return BillingsCargoOrderListingItemBillingStatus.REOPENED;
    case "REOPEN_REQUEST":
      return BillingsCargoOrderListingItemBillingStatus.REOPEN_REQUEST_SENT;
    default:
      return undefined;
  }
};

const createRouteAddresses = (
  responseDataItem: CargoCompanyOrderBillingsListItem,
): (string | string[])[] => {
  return responseDataItem.billingNodes.map((node) => {
    return node.description;
  });
};

const createListingItemBillingType = (
  billingType: BillingType,
): BillingsCargoOrderListingItemBillingType => {
  switch (billingType) {
    case BillingType.PUB_CARGO_2_RAILY:
      return BillingsCargoOrderListingItemBillingType.PUB_CARGO_2_RAILY;
    case BillingType.PRIV_CARGO_2_TAXI:
      return BillingsCargoOrderListingItemBillingType.PRIV_CARGO_2_TAXI;
  }
};

const createListingItem = (
  responseDataItem: CargoCompanyOrderBillingsListItem,
): BillingsCargoOrderListingItem => {
  return {
    uuid: responseDataItem.id,
    internalOrderId: responseDataItem.humanId,
    orderStartDate: new Date(responseDataItem.date),
    routeAddresses: createRouteAddresses(responseDataItem),
    passengers: responseDataItem.passengers,
    taxiCorporationName: responseDataItem.taxiCorporation,
    externalOrderId: responseDataItem.externalId,
    dispatchName: responseDataItem.dispatch,
    status: createListingItemStatus(responseDataItem),
    distance: responseDataItem.distance,
    amountForDistance: responseDataItem.amountForDistance,
    baseDistanceRate: responseDataItem.baseDistanceRate,
    stoppingTime: responseDataItem.hoursOfHaltings,
    stopoverCost: responseDataItem.amountForChargeHaltings,
    tollRoadsCost: responseDataItem.amountForChargeHighways,
    discountAmountPercent: responseDataItem.contractCorrectionPercentage,
    sumOfDiscounts: responseDataItem.sumOfDiscounts,
    totalCost: responseDataItem.allContributionsAmount,
    billingType: createListingItemBillingType(responseDataItem.billingType),
  };
};

const createListingItems = (
  responseDataItems: CargoCompanyOrderBillingsListItem[],
): BillingsCargoOrderListingItem[] => {
  return responseDataItems.map(createListingItem);
};

const billingsCargoOrderListingFactory = {
  createListingItems,
};

export default billingsCargoOrderListingFactory;
